import React, { useEffect, useState } from 'react'
import './choose-box.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { YYYYMMDDFormat } from '../../../assets/javascript/formate-functions'
import { useNavigate } from 'react-router-dom'
import { userAxios } from '../../../config/axios'
import toast from 'react-hot-toast'


const ServicedChooseBox = () => {
    const [form, setForm] = useState({ tech_id: null, tech_name: null, from_date: null, end_date: null, })
    const navigate = useNavigate()
    const [techList, setTechList] = useState([])
    const [loading, setLoading] = useState('fetch')

    const handleChange = (e) => {
        if (e.target.name === 'tech_id') {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
                tech_name: e.target.value === 'All' ? 'All Technicians' : techList?.filter((t) => t.value === e.target.value)?.[0]?.option
            })

            return;
        }

        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        navigate('/admin/serviced-list', {
            state: form
        })
    }

    useEffect(() => {
        setLoading('fetch')
        userAxios.get('/technicians').then((response) => {
            const list = response?.data || []
            setTechList([{ option: 'All', value: 'All' }, ...list.map((obj) => ({ option: obj.staff_name, value: obj.staff_id }))])
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
        })

        setForm({
            ...form,
            from_date: YYYYMMDDFormat(new Date().setDate(new Date().getDate() - 2)),
            end_date: YYYYMMDDFormat(new Date()),
            tech_id: 'All',
            tech_name: 'All Technicians'
        })
        // eslint-disable-next-line
    }, [])


    return (
        <div className="choose-box-div">
            <form action="" onSubmit={handleSubmit}>
                <NormalInput label='From date (MM-DD-YYYY)' name='from_date' type={'date'} value={form?.from_date} onChangeFun={handleChange}
                    max={form?.end_date} />
                <NormalInput label='End date (MM-DD-YYYY)' name='end_date' type={'date'} value={form?.end_date} onChangeFun={handleChange}
                    max={YYYYMMDDFormat(new Date())} />
                <SelectInput label='Technicians' name='tech_id' values={techList} onChangeFun={handleChange} />
                <div className="button-div">
                    <button type={'submit'}>Select</button>
                </div>
            </form>
            {loading === 'fetch' && <div className="loading-pop">
                <p>Loading...</p>
            </div>}
        </div>
    )
}

export default ServicedChooseBox